'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../../lib/cn.js';
import { Input } from './Input.js';
import inputStyles from './Input.module.css';
/** Password field with an in-field visibility toggle (Eye/EyeOff, right-
 * aligned like Input's loading spinner). Reveal state is view-only local
 * state — it never touches the form value, and flipping it preserves focus
 * and caret because only the input's `type` attribute changes. */
export const PasswordInput = forwardRef(function PasswordInput({ showLabel, hideLabel, ...rest }, ref) {
    const [visible, setVisible] = useState(false);
    return (_jsx(Input, { ...rest, ref: ref, type: visible ? 'text' : 'password', trailingSlot: _jsx("button", { type: "button", className: cn(inputStyles['revealToggle']), "aria-label": visible ? hideLabel : showLabel, "aria-pressed": visible, onClick: () => setVisible((v) => !v), children: visible ? (_jsx(EyeOff, { size: 17, "aria-hidden": "true" })) : (_jsx(Eye, { size: 17, "aria-hidden": "true" })) }) }));
});
